import React from 'react'
import { connect } from 'react-redux'
import UnCheckIcon from '../../assets/images/icons/icon_check_normal.png';
import CheckedIcon from '../../assets/images/icons/icon_check_hit.png';
import '../../assets/styles/components/pin.scss'
import { Validators } from '../../helpers/functions';

class PIN extends React.Component {
    constructor(props) {
        super(props);
        props.innerRef(this)
        this.state = {
            isChecked: false,
            pin: ''
        }
    }

    handleChangePIN = (event) => {
        const text = event.target.value;
        if(Validators.pin(text)) {
            this.setState({ pin: text })
        }
    }

    render() {
        const { isChecked, pin } = this.state;
        return (
            <div className='pin-container'>
                <header>Please enter the transaction password</header>
                <div className="pin-input">
                    <input type="text" value={pin} onChange={this.handleChangePIN} />
                </div>
                <div className='remember-option' onClick={() => this.setState({ isChecked: !isChecked })}>
                    <img src={isChecked ? CheckedIcon : UnCheckIcon} alt="check_icon" />
                    <span>No need password input in the same login process</span>
                </div>
            </div>
        )
    }
}
PIN.defaultProps = {
    innerRef: () => {}
}
export default connect(
    state => ({
        language: state.app.language
    })
)(PIN)
